import { useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";
import SelectHookFormSingle from "../../../../../components/SelectHookFormSingle";
import TextInputLabelHookForm from "../../../../../components/TextInputLabelHookForm";
import { useGetOfficeVendors } from "../../InvoiceCapture/hooks/useGetOfficeVendors";
import { IVendorInvoiceDetails } from "../../InvoiceCapture/types";

interface ForReviewFormProp {
  rowForEdit: IVendorInvoiceDetails | undefined;
  isEditState: boolean;
}

export const ForReviewForm: React.FC<ForReviewFormProp> = ({
  rowForEdit,
  isEditState,
}) => {
  const formMethods = useFormContext();

  const { register, control } = formMethods;

  const { data: officeVendorData } = useGetOfficeVendors();
  const officeVendorsOpt = officeVendorData?.data?.map(
    (x: {
      id: number;
      recordNumber: number;
      vendorId: number;
      vendorInvoiceId: number;
      vendorName: string;
      vendorUser: string;
      vendorPassword: string;
      vendorBankAccount: string;
      utilityType: string;
      webPage: string;
      accountNumber: string;
      officeId: number;
      officeName: string;
      officeStatus: string;
      officeState: string;
      officeCity: string;
      officeZipcode: string;
      officeStreet: string;
      officeBrand: string;
      vendorCode: string;
      officeDateOfAcquisition: Date;
    }) => {
      return {
        id: x.id,
        value: x.vendorId,
        label: x.accountNumber + " - " + x.vendorName,
        recordNumber: x.recordNumber,
        vendorId: x.vendorId,
        vendorInvoiceId: x.vendorInvoiceId,
        vendorName: x.vendorName,
        vendorUser: x.vendorUser,
        vendorPassword: x.vendorPassword,
        vendorBankAccount: x.vendorBankAccount,
        utilityType: x.utilityType,
        webPage: x.webPage,
        officeId: x.officeId,
        officeName: x.officeName,
        officeStatus: x.officeStatus,
        officeState: x.officeState,
        officeCity: x.officeCity,
        officeZipcode: x.officeZipcode,
        officeStreet: x.officeStreet,
        officeBrand: x.officeBrand,
        vendorCode: x.vendorCode,
        accountNumber: x.accountNumber,
        dateOfAcquisition: x.officeDateOfAcquisition,
      };
    }
  );

  useEffect(() => {
    if (isEditState) {
      formMethods.setValue("accountNumber", rowForEdit?.serviceAccount);
      formMethods.setValue("invoiceNumber", rowForEdit?.invoiceNumber);
      formMethods.setValue("officeId", rowForEdit?.officeId);
      formMethods.setValue("officeStatus", rowForEdit?.officeStatus);
      formMethods.setValue("officeName", rowForEdit?.officeName);
      formMethods.setValue("officeBrand", rowForEdit?.officeBrand);
      formMethods.setValue("amountPaid", rowForEdit?.amountPaid);
      formMethods.setValue("taxId", rowForEdit?.taxId);
      formMethods.setValue(
        "dateOfAcquisition",
        rowForEdit?.dateOfAcquisition?.slice(0, 10)
      );
      formMethods.setValue("vendorId", rowForEdit?.vendorId);
      formMethods.setValue(
        "dateCapture",
        rowForEdit?.dateCapture?.slice(0, 10)
      );
      formMethods.setValue(
        "bankReferenceDate",
        rowForEdit?.bankReferenceDate?.slice(0, 10)
      );
      formMethods.setValue("bankReference", rowForEdit?.bankReference);
      formMethods.setValue(
        "servicePeriodDate",
        rowForEdit?.servicePeriodDate?.slice(0, 10)
      );
      formMethods.setValue("officeStatus", rowForEdit?.officeStatus);
      formMethods.setValue("officeCity", rowForEdit?.officeCity);
      formMethods.setValue("officeState", rowForEdit?.officeState);
      formMethods.setValue("officeBrand", rowForEdit?.officeBrand);
      formMethods.setValue("billRefNumber", rowForEdit?.billReference);
      formMethods.setValue(
        "invoiceImageAttachment",
        rowForEdit?.invoiceImageAttachment
      );
    }
  }, []);

  return (
    <>
      <div className="grid sm:grid-cols-2 md:grid-cols-3 mx-4 mr-5 pb-2 gap-x-4 gap-y-2">
        <Controller
          name="vendorId"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <SelectHookFormSingle
              field={field}
              onChange={(e) => {
                field.onChange(e ? e.value : null);
                formMethods.setValue("officeName", e ? e.officeName : null);
                formMethods.setValue("officeId", e ? e.officeId : null);
                formMethods.setValue("officeStatus", e ? e.officeStatus : null);
                formMethods.setValue("officeBrand", e ? e.officeBrand : null);
                formMethods.setValue(
                  "accountNumber",
                  e ? e.accountNumber : null
                );
                formMethods.setValue("officeCity", e ? e.officeCity : null);
                formMethods.setValue("officeState", e ? e.officeState : null);
                formMethods.setValue("officeBrand", e ? e.officeBrand : null);
              }}
              value={field.value}
              options={officeVendorsOpt}
              label="Bank Account"
              className={undefined}
              required={false}
              isDisabled={undefined}
            />
          )}
        />
        <TextInputLabelHookForm
          name="officeStatus"
          label="Office Status"
          type="text"
          register={register("officeStatus", {})}
          maxLength={50}
          disabled={true}
        />
        <TextInputLabelHookForm
          name="officeName"
          label="Confie Office Name"
          type="text"
          register={formMethods.register("officeName", {})}
          //maxLength={50}
          disabled={true}
        />
        <TextInputLabelHookForm
          name="officeStreet"
          label="Office Street"
          type="text"
          register={register("officeStreet", {})}
          maxLength={50}
          disabled={true}
        />
        <TextInputLabelHookForm
          name="officeCity"
          label="Office City"
          type="text"
          register={register("officeCity", {})}
          maxLength={50}
          disabled={true}
        />
        <TextInputLabelHookForm
          name="officeState"
          label="Office State"
          type="text"
          register={register("officeState", {})}
          maxLength={50}
          disabled={true}
        />
        <TextInputLabelHookForm
          name="officeBrand"
          label="Confie Brand"
          type="text"
          register={register("officeBrand", {})}
          maxLength={50}
          disabled={true}
        />
        <TextInputLabelHookForm
          name="taxId"
          label="Tax ID"
          type="text"
          register={formMethods.register("taxId", {})}
          maxLength={50}
        />
        <TextInputLabelHookForm
          name="amountPaid"
          label="Amount Paid"
          type="number"
          register={formMethods.register("amountPaid", {})}
          maxLength={50}
        />
        <TextInputLabelHookForm
          name="servicePeriodDate"
          label="Service Period Date"
          type="date"
          register={register("servicePeriodDate", {
            required: {
              value: true,
              message: "Required Field",
            },
          })}
          maxLength={50}
        />
        <TextInputLabelHookForm
          name="invoiceNumber"
          label="Invoice Number"
          type="text"
          register={formMethods.register("invoiceNumber", {})}
          maxLength={50}
          disabled={false}
        />
        <TextInputLabelHookForm
          name="dateCapture"
          label="Date Capture"
          type="date"
          register={register("dateCapture", {
            required: {
              value: true,
              message: "Required Field",
            },
          })}
          maxLength={50}
          disabled={false}
        />
        <TextInputLabelHookForm
          name="billReference"
          label="Bill Reference"
          type="text"
          register={register("billReference", {})}
          maxLength={50}
          disabled={true}
        />
        <TextInputLabelHookForm
          name="paymentReference"
          label="Payment Reference No."
          type="text"
          register={register("paymentReference", {})}
          maxLength={50}
          disabled={true}
        />
        <TextInputLabelHookForm
          name="bankReference"
          label="Bank Reference No."
          type="text"
          register={register("bankReference", {
            required: {
              value: true,
              message: "Required Field",
            },
          })}
          maxLength={50}
          disabled={false}
          required={true}
          className={
            formMethods.formState.errors.bankReference &&
            "border-2 border-red-500 col-span-2 "
          }
        />
        <TextInputLabelHookForm
          name="bankReferenceDate"
          label="Bank Reference Date."
          type="date"
          register={register("bankReferenceDate", {
            required: {
              value: true,
              message: "Required Field",
            },
          })}
          maxLength={50}
          disabled={false}
          required={true}
          className={
            formMethods.formState.errors.bankReferenceDate &&
            "border-2 border-red-500 col-span-2 "
          }
        />
      </div>
      <div className="space-y-1 mr-6">
        <TextInputLabelHookForm
          name="vendorCode"
          label="Vendor ID"
          type="text"
          register={register("vendorCode", {})}
          maxLength={50}
          disabled={true}
        />
        <TextInputLabelHookForm
          name="vendorBankAccount"
          label="Bank Account"
          type="text"
          register={undefined}
          maxLength={50}
          disabled={true}
        />
        <TextInputLabelHookForm
          name="invoiceAvailabilityDay"
          label="Invoice Availability Day"
          type="text"
          register={register("invoiceAvailabilityDay", {})}
          maxLength={50}
          disabled={false}
        />
        <TextInputLabelHookForm
          name="vendorName"
          label="Vendor Name"
          type="text"
          register={register("vendorName", {})}
          maxLength={50}
          disabled={true}
        />
        <TextInputLabelHookForm
          name="utilityType"
          label="Utility Type"
          type="text"
          register={register("utilityType", {})}
          maxLength={50}
          disabled={true}
        />
        <TextInputLabelHookForm
          name="dateOfAcquisition"
          label="Date of Acquisition"
          type="date"
          register={register("dateOfAcquisition", {})}
          disabled={false}
        />

        <TextInputLabelHookForm
          name="webPage"
          label="Web Page"
          type="url"
          register={register("webPage", {})}
          maxLength={50}
          disabled={true}
        />
        <TextInputLabelHookForm
          name="vendorUser"
          label="User"
          type="text"
          register={register("vendorUser", {})}
          maxLength={50}
          disabled={true}
        />
        <TextInputLabelHookForm
          name="vendorPassword"
          label="Password"
          type="text"
          register={register("vendorPassword", {})}
          maxLength={50}
          disabled={true}
        />
        <TextInputLabelHookForm
          name="glSubAccounts"
          label="GL/Subaccounts"
          type="text"
          register={undefined}
          maxLength={50}
        />
        <TextInputLabelHookForm
          name="w9"
          label="W9"
          type="text"
          // register={register("w9", {})}
          maxLength={50}
          disabled={true}
        />
        <TextInputLabelHookForm
          name="invoiceImageAttachment"
          label="Invoice Image/Attachment"
          type="text"
          register={register("invoiceImageAttachment", {})}
          maxLength={50}
          disabled={true}
        />
      </div>
      <TextInputLabelHookForm
        name="noteSection"
        label="Note"
        type="text"
        register={register("noteSection", {})}
        maxLength={50}
        disabled={true}
      />
    </>
  );
};
